import React from "react";
import PropTypes from "prop-types";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router } from "react-router-dom";
import { redirects } from "../../config";

export const history = createBrowserHistory();

const MainRouter = ({ children }) => {
  const { pathname } = window.location;

  // Lista de rotas conhecidas e válidas
  const validRoutes = [
    "/home",
    "/denuncia",
    "/previdencia",
    "/acidentespessoais",
    "/segurodevida",
    "/segurovidasenior",
    "/microsseguroamparo",
    "/seguroprestamista",
    "/segurodividazero",
    "/segurodividazerofies",
    "/segurovidaprodutorrural",
    "/informe-de-rendimentos",
    "/whatsapp",
    "/app",
    "/sinistro",
    "/sinistros",
    "/ouvidoria",
    "/404",
    "/"
  ];

  // Verifica se é uma rota válida (começa com alguma das rotas válidas)
  const isValidRoute = validRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );

  // Verificar se existe um redirecionamento específico configurado
  const redirect = redirects.find(([to]) => to === pathname);
  if (redirect) {
    const [, from] = redirect;
    window.location = from;
    return null;
  }

  // Se não for uma rota válida e não tiver redirecionamento específico, redirecionar para home
  if (!isValidRoute && pathname !== "/home") {
    window.location = "/404";
    return null;
  }

  return <Router>{children}</Router>;
};

MainRouter.propTypes = {
  children: PropTypes.element.isRequired
};

export default MainRouter;
